import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import Navbar from './Navbar'
import Sidebar from './Sidebar'
import { useLocation } from 'react-router-dom'
import InternetConnectivity from '../../shared/InternetConnectivity'

const AuthenticatedLayout = ({ children }) => {
  const { i18n } = useTranslation()
  const [activeSection, setActiveSection] = useState('Dashboard')
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
    const savedState = localStorage.getItem('isSidebarCollapsed')
    return savedState ? JSON.parse(savedState) : true
  })
  const location = useLocation()

  useEffect(() => {
    const pathName = location.pathname.split('/').filter(Boolean).pop() || ''
    setActiveSection(pathName.replace(/-/g, ' '))
  }, [location.pathname])

  useEffect(() => {
    localStorage.setItem('isSidebarCollapsed', JSON.stringify(isSidebarCollapsed))
  }, [isSidebarCollapsed])

  return (
    <div
      key={i18n.language}
      dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
      className='flex items-center !h-screen !justify-center overflow-hidden'
    >
      <InternetConnectivity />
      <div className='hidden md:block'>
        <Sidebar
          isCollapsed={isSidebarCollapsed}
          onToggleCollapse={() => setIsSidebarCollapsed(prev => !prev)}
        />
      </div>
      <div className='w-full flex-col h-full flex !overflow-hidden'>
        <Navbar activeSection={activeSection} />
        <div className='min-h-[calc(100vh-50px)] h-full w-full overflow-hidden !bg-white rounded-md'>
          {children}
        </div>
      </div>
    </div>
  )
}

export default AuthenticatedLayout
